// import throttle from "lodash.throttle";
// import debounce from "lodash.debounce";

colourSelectors();
function colourSelectors() {
  const selectors = document.querySelectorAll(".pdp-colour-selectors > a");
  const title = document.querySelector("[selectors-title]");

  if (!selectors) return;
  for (const selector of selectors) {
    selector.addEventListener(
      "pointerenter",
      () => (title.innerText = selector.dataset.title)
    );
    selector.addEventListener(
      "pointerleave",
      () => (title.innerText = title.dataset.title)
    );
  }
}

productAccordions();
function productAccordions() {
  const panels = document.querySelectorAll(".pdp-accordion .panel");
  const checkboxes = document.querySelectorAll("[accordions-outer] .checkbox");

  if (!panels) return;

  // Close other panels on opening one
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      checkboxes.forEach((c) => {
        if (c.id === checkbox.id) return;
        c.checked = false;
      });
    });
  });

  // Resize observers for panels
  const resizer = new ResizeObserver((entries) => {
    for (let entry of entries) {
      entry.target.style.setProperty(
        "--height",
        entry.target.scrollHeight + "px"
      );
    }
  });

  for (const panel of panels) {
    panel.style.setProperty("--height", panel.scrollHeight + "px");
    resizer.observe(panel);
  }
}

productPairings();
function productPairings() {
  const els = document.querySelectorAll(".pdp-accordion-pairings");
  if (!els) return;

  els.forEach((el) => {
    setObservableHeight(el);

    const track = el.querySelector(".panel-inner-pairings");
    if (!track || track.dataset.dragScrollInitialized === "true") return;

    initDragScroll(track);
  });
}

function initDragScroll(track) {
  track.dataset.dragScrollInitialized = "true";

  const interactiveSelector = "a, button, input, select, textarea, label";
  let pos = { left: 0, x: 0 };
  let isPointerDown = false;
  let activePointerId = null;
  let hasDragged = false;

  track.addEventListener("pointerdown", (event) => {
    if (event.pointerType === "mouse" && event.button !== 0) return;
    if (event.target.closest(interactiveSelector)) return;

    isPointerDown = true;
    activePointerId = event.pointerId;
    hasDragged = false;
    pos = {
      left: track.scrollLeft,
      x: event.clientX,
    };

    if (track.setPointerCapture) {
      track.setPointerCapture(event.pointerId);
    }

    track.classList.add("is-dragging");
  });

  track.addEventListener("pointermove", (event) => {
    if (!isPointerDown || event.pointerId !== activePointerId) return;

    const dx = event.clientX - pos.x;

    if (Math.abs(dx) > 4) hasDragged = true;

    track.scrollLeft = pos.left - dx;
  });

  const endDrag = (event) => {
    if (!isPointerDown || event.pointerId !== activePointerId) return;

    isPointerDown = false;
    activePointerId = null;

    if (track.releasePointerCapture) {
      try {
        track.releasePointerCapture(event.pointerId);
      } catch (_error) {
        // Ignore release errors when capture is already gone.
      }
    }

    track.classList.remove("is-dragging");

    if (hasDragged) {
      window.setTimeout(() => {
        hasDragged = false;
      }, 0);
    }
  };

  track.addEventListener("pointerup", endDrag);
  track.addEventListener("pointercancel", endDrag);
  track.addEventListener("lostpointercapture", endDrag);

  track.addEventListener(
    "click",
    (event) => {
      if (!hasDragged) return;

      event.preventDefault();
      event.stopPropagation();
      hasDragged = false;
    },
    true
  );
}

atcQuickView();
function atcQuickView() {
  const bar = document.querySelector(".pdp-atc-quickview");
  const atc = document.querySelector("#main-product-form");
  const footer = document.querySelector("#shopify-section-footer");
  if (!bar || !atc || !footer) return;

  let ticking = false;

  const update = () => {
    ticking = false;

    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    const atcTop = atc.getBoundingClientRect().top + window.scrollY;
    const footerTop = footer.getBoundingClientRect().top + window.scrollY;
    const shouldShow =
      isMobile && window.scrollY > atcTop && window.scrollY < footerTop;

    bar.classList.toggle("active", shouldShow);
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  update();
  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", requestUpdate);
}

pdpImageGallery();
function pdpImageGallery() {
  const galleries = document.querySelectorAll(".pdp-gallery-outer");
  if (!galleries.length) return;

  galleries.forEach((galleryOuter) => {
    const gallery = galleryOuter.querySelector(".pdp-gallery");
    const thumbsTrack = galleryOuter.querySelector(".pdp-gallery-thumbs");
    const prevButton = galleryOuter.querySelector("[data-pdp-gallery-prev]");
    const nextButton = galleryOuter.querySelector("[data-pdp-gallery-next]");
    if (!gallery || !thumbsTrack || gallery.dataset.initialized === "true")
      return;

    gallery.dataset.initialized = "true";
    initGallery({ gallery, thumbsTrack, prevButton, nextButton });
  });

  function initGallery({ gallery, thumbsTrack, prevButton, nextButton }) {
    // Pointer drag/swipe support
    let pos = { top: 0, left: 0, x: 0, y: 0 };
    let isPointerDown = false;
    let activePointerId = null;

    const pointerDownHandler = function (e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;

      isPointerDown = true;
      activePointerId = e.pointerId;
      pos = {
        left: gallery.scrollLeft,
        top: gallery.scrollTop,
        x: e.clientX,
        y: e.clientY,
      };

      if (gallery.setPointerCapture) {
        gallery.setPointerCapture(e.pointerId);
      }

      gallery.style.cursor = "grabbing";
      gallery.style.userSelect = "none";
    };

    const pointerMoveHandler = function (e) {
      if (!isPointerDown || e.pointerId !== activePointerId) return;

      const dx = e.clientX - pos.x;
      const dy = e.clientY - pos.y;

      gallery.scrollTop = pos.top - dy;
      gallery.scrollLeft = pos.left - dx;
    };

    const pointerUpHandler = function (e) {
      if (!isPointerDown || e.pointerId !== activePointerId) return;

      isPointerDown = false;
      activePointerId = null;

      if (gallery.releasePointerCapture) {
        try {
          gallery.releasePointerCapture(e.pointerId);
        } catch (_error) {
          // Ignore release errors when capture is already gone.
        }
      }

      gallery.style.cursor = "grab";
      gallery.style.removeProperty("user-select");
    };

    gallery.addEventListener("pointerdown", pointerDownHandler);
    gallery.addEventListener("pointermove", pointerMoveHandler);
    gallery.addEventListener("pointerup", pointerUpHandler);
    gallery.addEventListener("pointercancel", pointerUpHandler);
    gallery.addEventListener("lostpointercapture", pointerUpHandler);

    // Get thumbs
    const thumbs = thumbsTrack.querySelectorAll(".thumb");
    const thumbsInner = thumbsTrack.firstElementChild;
    const getSlideWidth = () => gallery.firstElementChild?.scrollWidth || 0;
    const getActiveIndex = () => {
      const slideWidth = getSlideWidth();
      if (!slideWidth) return 0;
      return Math.round(gallery.scrollLeft / slideWidth);
    };

    const updateGalleryState = () => {
      const activeIndex = getActiveIndex();

      thumbs.forEach((t) => t.classList.remove("active"));
      const thumb = thumbs[activeIndex];
      if (thumb) {
        thumb.classList.add("active");

        thumbsInner.scrollTo({
          left: thumb.offsetLeft - 20,
          behavior: "smooth",
        });
      }

      if (prevButton) {
        prevButton.disabled = activeIndex <= 0;
      }

      if (nextButton) {
        nextButton.disabled = activeIndex >= thumbs.length - 1;
      }
    };

    // Run scroll function
    gallery.onscroll = debounce(updateGalleryState, 100);

    // Thumb navigation
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener("click", (event) => {
        event.preventDefault();
        gallery.scrollTo({
          left: getSlideWidth() * index,
          behavior: "smooth",
        });
      });
    });

    if (prevButton) {
      prevButton.addEventListener("click", () => {
        const activeIndex = getActiveIndex();
        const targetIndex = Math.max(0, activeIndex - 1);

        gallery.scrollTo({
          left: getSlideWidth() * targetIndex,
          behavior: "smooth",
        });
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", () => {
        const activeIndex = getActiveIndex();
        const targetIndex = Math.min(thumbs.length - 1, activeIndex + 1);

        gallery.scrollTo({
          left: getSlideWidth() * targetIndex,
          behavior: "smooth",
        });
      });
    }

    updateGalleryState();
  }
}
